import {DeliveryMethodStoreProps} from '../../../types/checkoutApp.types';
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor';
import {CheckoutService} from '../../services/checkout/CheckoutService';
import {BIService} from '../../services/checkout/BIService';
import {FedopsInteractions} from '../../../components/Checkout/constants';
import {NavigationService} from '../../services/checkout/NavigationService';

export type DeliveryMethodStoreConfig = {
  flowAPI: ControllerFlowAPI;
  checkoutService: CheckoutService;
  navigationService: NavigationService;
  biService: BIService;
  updateComponent: () => void;
};

export class DeliveryMethodStore {
  private readonly flowAPI: ControllerFlowAPI;
  private readonly checkoutService: CheckoutService;
  private readonly navigationService: NavigationService;
  private readonly biService: BIService;
  private readonly updateComponent: () => void;
  private isUpdatingShippingOption: boolean;

  constructor({flowAPI, checkoutService, biService, updateComponent, navigationService}: DeliveryMethodStoreConfig) {
    this.flowAPI = flowAPI;
    this.checkoutService = checkoutService;
    this.navigationService = navigationService;
    this.biService = biService;
    this.updateComponent = updateComponent;
    this.isUpdatingShippingOption = false;
  }

  private readonly setShippingOption = async (shippingOptionId: string): Promise<void> => {
    this.flowAPI.fedops.interactionStarted(FedopsInteractions.ChangeDeliveryMethodInteraction);
    this.flowAPI.panoramaClient?.transaction(FedopsInteractions.ChangeDeliveryMethodInteraction).start();
    this.isUpdatingShippingOption = true;
    this.updateComponent();
    await this.checkoutService.setShippingOption(shippingOptionId);
    this.isUpdatingShippingOption = false;
    this.updateComponent();
    this.flowAPI.fedops.interactionEnded(FedopsInteractions.ChangeDeliveryMethodInteraction);
    this.flowAPI.panoramaClient?.transaction(FedopsInteractions.ChangeDeliveryMethodInteraction).finish();
  };

  private readonly beforePlaceOrderClicked = (): void => {
    this.navigationService.isFastFlow &&
      this.biService.deliveryMethodSet({
        cart: this.checkoutService.cart,
        cartSummary: this.checkoutService.cartSummary,
        tempShipping: this.checkoutService.tempShipping,
        originalShippingTitle: this.checkoutService.originalShippingTitle,
      });
  };

  public toProps(): DeliveryMethodStoreProps {
    return {
      canShipToDestination: !!this.checkoutService.cart.deliveryInfo.method,
      isUpdatingShippingOption: this.isUpdatingShippingOption,
      setShippingOption: this.setShippingOption,
      beforePlaceOrderClicked: this.beforePlaceOrderClicked,
      locale: this.flowAPI.translations.config.language,
    };
  }
}
